import React from 'react';
import { newPasswordValidationType } from 'utils/types';

import { Typography } from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';

import SetPasswordInstruction from './SetPasswordInstruction';

type SetPasswordInstructionsType = {
  passwordValidations: newPasswordValidationType;
  validationError: string | undefined;
};

const SetPasswordInstructions = ({
  passwordValidations,
  validationError,
}: SetPasswordInstructionsType): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      {validationError && (
        <Typography variant="caption">
          {validationError}
          <br />
        </Typography>
      )}
      <SetPasswordInstruction
        errorState={passwordValidations['length']}
        message={t('setPasswordInstructions.alteastEightCharactersRequired')}
      />
      <SetPasswordInstruction
        errorState={passwordValidations['upperCase']}
        message={t('setPasswordInstructions.upperCaseRequired')}
      />
      <SetPasswordInstruction
        errorState={passwordValidations['lowerCase']}
        message={t('setPasswordInstructions.lowerCaseRequired')}
      />
      <SetPasswordInstruction
        errorState={passwordValidations['number']}
        message={t('setPasswordInstructions.numberRequired')}
      />
    </>
  );
};

export default SetPasswordInstructions;
